





































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
 

class PageGoodsExchangeRequest extends PageRequest {
  Keyword: string;
  stime: Date;
  etime: Date;
  Vid:number;
  operate:string;
}

 @Component({
       
    })
export default class GoodsExchange extends AbpBase {
  
  //filters
  pagerequest: PageGoodsExchangeRequest = new PageGoodsExchangeRequest();
  creationTime: Date[] = [];
        editModalShow: boolean = false;

    
    VareasChange(val:number){
   
      this.pagerequest.Vid =val ;
    }
    
 edit() {
    this.editModalShow = true;
  }
   
  get list() {
    return this.$store.state.goodsexchange.list;
  }
  get loading() {
    
    return this.$store.state.goodsexchange.loading;
  }
  get vareas(){
      //社区下的小区
            
            return this.$store.state.goodsexchange.vareas;
  }
  create() {
    
  }

  pageChange(page: number) {
    this.$store.commit("goodsexchange/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("goodsexchange/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
     ;
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters

    if (this.creationTime.length > 0) {
      this.pagerequest.stime = this.creationTime[0];
    }
    if (this.creationTime.length > 1) {
      this.pagerequest.etime = this.creationTime[1];
    }

    await this.$store.dispatch({
      type: "goodsexchange/getAll",
      data: this.pagerequest,
    });
  }
    async getVreaAll() {
    await this.$store.dispatch({
      type: "goodsexchange/getVAreaAllData",
    });
    

  }
  
 
  get pageSize() {
    return this.$store.state.goodsexchange.pageSize;
  }
  get totalCount() {
    return this.$store.state.goodsexchange.totalCount;
  }
  get currentPage() {
    return this.$store.state.goodsexchange.currentPage;
  }

  columns = [
     
    {
      title: "卡号",
      render: (h: any, params: any) => {
         //'qrcode', 'integralCard', 'otherCard'
           var qrcode=params.row.bhUsers.qrcode;
          if(qrcode==null||qrcode==""){
            qrcode=params.row.bhUsers.integralCard;
          }
          if(qrcode==null||qrcode==""){
            qrcode=params.row.bhUsers.otherCard;
          }

        return h("span", qrcode);
      },
    },

    
     {
      title: "地址信息",
      render: (h: any, params: any) => {
      let useraddr=params.row.bhUsers.useraddr;
      if(useraddr==''){
         useraddr= params.row.bhUsers.uzhuang+"-"+ params.row.bhUsers.udanyuan+"-"+params.row.bhUsers.ushi;
      }
     

        return h("span", useraddr);
      },
    },
   {
      title: this.L("VilName"),
      render: (h: any, params: any) => {
        return h("span", params.row.bhUsers.vArea.vilname);
      },
    },
    
    {
      title: "物品名称",
      render: (h: any, params: any) => {
        var goodsname=params.row.goodsName
        if(goodsname==""||goodsname==null){
           goodsname=params.row.bHgoods.goodsname;
        }
        return h("span", goodsname);
      },
    },
     {
      
      title: this.L("单个分值"),
      key: "goodsprice",
      width: 200,
    },
     {
      
      title: this.L("数量"),
      key: "goodsnum",
      width: 200,
    },
    
      {
      
      title: this.L("总积分"),
      key: "goodstotalprice",
      width: 200,
    },
     {
      
      title: this.L("操作人"),
      key: "operate",
      width: 150,
    },
    
     
     
    {
      title: this.L("Addtime"),
     
      render: (h: any, params: any) => {
        return h("span", new Date(params.row.createtime).toLocaleString());
      },
    },
  /*   {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
               
                  this.$store.commit("rblist/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("详细")
          ),
          
        ]);
      },
    },*/

    
  ];
  async created() {
    
    this.getVreaAll();
 
    this.getpage();
  
  }
  //导出
   async  exportExcel() {
   
     this.pagerequest.maxResultCount = 999999999;
     this.pagerequest.skipCount =0;
     let lt= await this.$store.dispatch({
      type: "goodsexchange/getAllexportExcel",
      data: this.pagerequest,
    });
  
      if(lt!=null){       
       
            
            
			   	require.ensure( [], () => {
					const { export_json_to_excel } = require('@/lib/excel/export2Excel.js');
          
					// 这里深拷贝，修改值时不会影响到原对象
			 
					lt.map((item) => { // 这里修改要下载的字段内容
        
					   
             
        
         
            
            item.qrcode='';
            item.vilname='';

             if(item.bhUsers!=null){
                item.uname=item.bhUsers.username;
                  
                    var qrcode=item.bhUsers.qrcode;
          if(qrcode==null||qrcode==""){
            qrcode=item.bhUsers.integralCard;
          }
          if(qrcode==null||qrcode==""){
            qrcode=item.bhUsers.otherCard;
          }
 item.qrcode=qrcode;

                if(item.bhUsers.vArea!=null){
                    item.vilname=item.bhUsers.vArea.vilname
                }
                 
             }
             let useraddr=item.bhUsers.useraddr;
             if(useraddr==''){
                useraddr= item.bhUsers.uzhuang+"-"+ item.bhUsers.udanyuan+"-"+item.bhUsers.row.bhUsers.ushi;
             }    
             item.useraddr=useraddr;
             let goodsname=item.goodsName;;
             if(goodsname==""||goodsname==null){
                 goodsname= item.bHgoods.goodsname

             }
            

             item.goodsname=goodsname;
             item.createtime=new Date(item.createtime).toLocaleString()
             
             
            item.rbtime=new Date(item.rbtime).toLocaleString()
					  return item;
					});
    
					const filterVal = ['id','qrcode','useraddr','vilname', 'goodsname', 'goodsprice', 'goodsnum', 'goodstotalprice','createtime','operate'];// 取出要下载的表头字段
					const tHeader = ['编号','卡号','地址','小区','物品名称','单个分值','数量','总积分','创建时间','操作人'];// 把表头字段定义成想要的中文或英文
					const data = this.formatJson(filterVal, lt);
					  export_json_to_excel(tHeader, data, '物品兑换');// 定义excel下载成功的表名
					});			
								
             }

        }

			formatJson(filterVal, jsonData) {
			     return jsonData.map(v => filterVal.map(j => v[j]))
			}
       userRule={
          
          //  uareaid:[{type:'number', required: true,message:'请选择小区',trigger: 'change'}],
 
            
      
        }
        

   
  
}
